/**
 * Clear all locally persisted md data — draft, settings, recents, pins, hints.
 */

import { safeRemoveItem } from './safeStorage'
import { clearAllRecents } from './recents'

const EXTRA_KEYS = ['md.swipeHintSeen', 'md.fileHandle'] as const

export async function clearAllLocalData(): Promise<void> {
  safeRemoveItem('md.content')
  safeRemoveItem('md.settings')
  for (const key of EXTRA_KEYS) safeRemoveItem(key)
  await clearAllRecents()
}
